export default __webpack_public_path__ + "static/media/me-background.6406d9c3.svg";